<div mdbModal #seleccionarCliente="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'SEARCH'">
          Seleccionar vendedor
        </h4>
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'VIEW_SELECTED'">
          Seleccionados
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formData' (ngSubmit)="buscar(1)" novalidate>
        <div class="modal-body" *ngIf="mode === 'SEARCH'">

          <!-- <div class="row">
            <div class="col">
              <strong>Buscar por: </strong>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorNombre" formControlName="buscarPor"
                  [value]="TIPO_NOMBRE" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorNombre">Nombre</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorRut" formControlName="buscarPor"
                  [value]="TIPO_RUT" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorRut">Rut</label>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="rut" class="form-control" placeholder="Rut" #rut formControlName="rut"
                  formatRut />
                <label for="rut">Rut</label>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="codigo" class="form-control" placeholder="Código" #codigo
                  formControlName="codigo" onlyNumbers />
                <label for="codigo">Código</label>
              </div>
            </div>
            <div class="col">
              <button mdbBtn type="submit" color="info" mdbWavesEffect>
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar
              </button>
            </div>
          </div>

          <!-- <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div> -->

          <table class="table table-striped table-hover table-sm align-middle" *ngIf="data && busquedaIniciada">
            <thead class="grey lighten-2">
              <tr>
                <th>
                  <ng-container *ngIf="multiple">
                    <mdb-checkbox (change)='checkAllChange($event)' [disabled]="!data || data.length === 0">
                      <span>
                        RUT
                      </span>
                    </mdb-checkbox>
                  </ng-container>
                  <ng-container *ngIf="!multiple">
                    RUT
                  </ng-container>
                </th>
                <th>Código</th>
                <th>Nombre</th>
                <th>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && data?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let cliente of data">
                <td *ngIf="multiple">
                  <mdb-checkbox [checked]="cliente.checked" (change)='checkCliente(cliente)'>
                    <span>
                      {{ cliente.rutFormato | rut }}
                    </span>
                  </mdb-checkbox>
                </td>
                <td *ngIf="!multiple">{{ cliente.rutFormato | rut }}</td>
                <td>{{ cliente.codigo }}</td>
                <td>{{ cliente.nombre }}</td>

                <td *ngIf="!multiple">
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="selectData(cliente)">
                    Seleccionar
                  </button>
                </td>
                <td *ngIf="multiple">
                </td>
              </tr>
            </tbody>
            <ng-container *ngIf="data.length > 0">
              <app-pagination *ngIf="!config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChange($event)"></app-pagination>
              <app-pagination *ngIf="config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChangeLocal($event)"></app-pagination>
            </ng-container>
          </table>
        </div>
      </form>
    </div>
  </div>
</div>